import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DatasheetCard } from "../../Components/DatasheetCard";

export const Insights = () => {
  let dataSheet = [
    { title: "Sentiment", time: "1h", progress: "70" },
    { title: "Price", time: "1h", progress: "70" },
    { title: "Sentiment % Change", time: "1h", progress: "70" },
    { title: "Stacked Regression Feature", time: "1h", progress: "70" },
  ];

  let checkboxArr = [
    { title: "Price Data", checked: true },
    { title: "Sentiment Data", checked: true },
    { title: "Sentiment Pct Change Data", checked: true },
    { title: "Total News Articles", checked: false },
    { title: "Robust Regression Feature", checked: false },
    { title: "Random Forest Regression Feature", checked: false },
    { title: "Stacked Regression Feature", checked: true },
    { title: "Multi Perceptron Regression Feature", checked: false },
    { title: "GRN Regression Feature", checked: false },
    { title: "GRU Regression Feature", checked: false },
    { title: "LSTM Regression Feature", checked: false },
  ];
  return (
    <div className="bg-light py-5 px-3 p-sm-5">
      <Container fluid>
        <Row>
          <Col xl="8" className="mb-4">
            <div>
              <h5 className="text-black">Datasheet of DOGEUSD</h5>
              <Row>
                {dataSheet.map((data, index) => {
                  return (
                    <Col md="6" lg="6" key={index} className="mb-4">
                      <DatasheetCard data={data} />
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Col>
          <Col xl="4" className="mb-4">
            <div className="h-100 d-flex flex-column">
              <h5 className="text-black">Insights</h5>
              <div className="bg-white p-3 rounded-16 flex-fill mb-4">
                <FormGroup>
                  {checkboxArr.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        control={
                          item.checked === true ? (
                            <Checkbox defaultChecked />
                          ) : (
                            <Checkbox />
                          )
                        }
                        className="text-gray"
                        label={item.title}
                      />
                    );
                  })}
                </FormGroup>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
